<div class="single-host layout-spacing" data-testid="single-host">
    <div class="single-host__details details" data-testid="single-host-details">
        <ntv-card variant="elevated" rounded="xl" shadow="md">
            <div class="host-card" data-testid="host-card">
                <div class="details__image" data-testid="details-image">
                    <img
                        [src]="$safeNavigationMigration(hostData()?.image)"
                        alt="Host Image"
                        data-testid="single-host-img" />
                </div>
                <div class="details__info" data-testid="details-info">
                    <div class="details__info-title" data-testid="details-info-title">
                        <h3>{{ hostData()?.name?.value }}</h3>

                        <div class="host-btn" data-testid="host-btn">
                            <ntv-button
                                rounded="md"
                                variant="primary"
                                size="xl"
                                (buttonClick)="isEditModalVisible.set(true)">
                                <div class="main-btn" data-testid="main-btn">
                                    Modify

                                    <svg width="14" height="14">
                                        <use [attr.href]="spritePath + '#' + icons['tv']"></use>
                                    </svg>
                                </div>
                            </ntv-button>
                        </div>
                    </div>
                    <div
                        class="status-badge"
                        [class.status-badge--active]="hostData()?.status === 'Active'"
                        [class.status-badge--inactive]="hostData()?.status === 'Inactive'">
                        {{ hostData()?.status }}
                    </div>
                    <div class="details__info-data" data-testid="details-info-data">
                        <div class="data-left" data-testid="data-left">
                            @for (item of hostData()?.dealerInfo; track $index) {
                                <div class="data-info" data-testid="data-info">
                                    <p class="label">{{ item.label }}</p>
                                    <span class="value" data-testid="single-host-value-span">{{
                                        item.value
                                    }}</span>
                                </div>
                            }
                        </div>

                        <div class="data-right" data-testid="data-right">
                            <div class="data-hours" data-testid="data-hours">
                                @for (item of businessHours; track $index) {
                                    <div class="data-info-hours" data-testid="data-info-hours">
                                        <p class="label">{{ item.label }}</p>
                                        <span
                                            class="value"
                                            data-testid="single-host-value-span-2"
                                            >{{ item.value }}</span
                                        >
                                    </div>
                                }
                            </div>
                            <div class="data-tags" data-testid="data-tags">
                                <p class="label">TAGS</p>
                                <div class="data-info-tags" data-testid="data-info-tags">
                                    @for (item of tags; track $index) {
                                        <span
                                            class="value-tag"
                                            [style.backgroundColor]="item.color"
                                            data-testid="single-host-value-tag-span"
                                            >{{ item.label }}</span
                                        >
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ntv-card>
    </div>
    <div class="single-host__stats" data-testid="single-host-stats">
        @for (host of statsData(); track host.title + $index) {
            <app-stats-card [statsData]="host" [hasTotal]="true" width="100%"></app-stats-card>
        }
    </div>
    <div class="single-host__tabs" data-testid="single-host-tabs">
        <ntv-tabs
            [tabs]="tabs"
            [activeIndex]="activeTab()"
            (tabChange)="onTabChange($event)"></ntv-tabs>

        <div class="tab-content-container" data-testid="single-host-tab-content-container-div">
            <!-- Licenses Tab Content -->
            @if (activeTab() === 0) {
                <div class="tab-content" data-testid="single-host-tab-content-div">
                    <app-table-panel
                        [columns]="licenseColumns"
                        [data]="licenseData()"
                        [loading]="isLicensesLoading()"
                        [toolbarButtons]="toolbarButtons()"
                        [placeholder]="'Search Host Name, Address, City, Postal Code, DMA Name or #Tag '"
                        [tableTitle]="'Licenses'"
                        [tableHeight]="'auto'"
                        [hasCheckBox]="true"
                        (actionClick)="onActionClick($event)"
                        (searchValueChange)="onSearch($event)"
                        (selectionChange)="onSelectionChange($event)"
                        (cellClick)="onCellClick($event)"
                        (toolbarAction)="onToolbarAction($event)">
                        <ntv-button
                            toolbar-actions
                            class="action-btn action-btn--quick"
                            size="xl"
                            rounded="md"
                            (buttonClick)="quickActionPopover.toggle($event)">
                            <div class="action-btn__content" data-testid="single-host-main-btn-div">
                                <svg width="14" height="14" class="action-btn__icon">
                                    <use [attr.href]="spritePath + '#' + icons['gear']"></use>
                                </svg>
                                <span
                                    class="action-btn__text"
                                    data-testid="single-host-action-btn-text-span"
                                    >Quick Action</span
                                >
                            </div>
                        </ntv-button>
                        <ntv-popover
                            #quickActionPopover
                            placement="bottom-start"
                            class="quick-action-popover">
                            @for (option of quickActionOptions; track option.value) {
                                <div
                                    class="quick-action-item"
                                    (click)="onQuickAction(option.value); quickActionPopover.hide()"
                                    data-testid="single-host-quick-action-item-div">
                                    <svg
                                        viewBox="0 0 14 14"
                                        width="14"
                                        height="14"
                                        class="quick-action-item__icon">
                                        <use
                                            [attr.href]="
                                                spritePath + '#' + icons['refreshGreen']
                                            "></use>
                                    </svg>
                                    <span>{{ option.label }}</span>
                                </div>
                            }
                        </ntv-popover>

                        <ntv-button
                            toolbar-actions
                            variant="primary"
                            class="action-btn action-btn--assign"
                            size="xl"
                            rounded="md"
                            (buttonClick)="isAssignModalVisible.set(true)">
                            <div
                                class="action-btn__content"
                                data-testid="single-host-main-btn-div-2">
                                <svg width="14" height="14" class="action-btn__icon">
                                    <use [attr.href]="spritePath + '#' + icons['barcode']"></use>
                                </svg>
                                <span
                                    class="action-btn__text"
                                    data-testid="single-host-action-btn-text-span-2"
                                    >Assign License</span
                                >
                            </div>
                        </ntv-button>
                    </app-table-panel>
                </div>
            }

            <!-- Terminal and Activity Tab Content -->
            @if (activeTab() === 1) {
                <div class="tab-content" data-testid="tab-content">
                    <app-contents></app-contents>
                </div>
            }

            <!-- Setting Tab Content -->
            @if (activeTab() === 2) {
                <div class="tab-content" data-testid="tab-content">
                    <app-activity></app-activity>
                </div>
            }
        </div>
    </div>
</div>

@if (isEditModalVisible()) {
    <ntv-modal
        [isVisible]="isEditModalVisible()"
        [grayBackground]="false"
        [size]="'large'"
        (modalClose)="isEditModalVisible.set(false)">
        <div modal-header class="modal__header" data-testid="modal-header">
            <div class="modal__header-title" data-testid="modal-header-title">
                <h3>Edit Host</h3>
                <p>You can update host details here</p>
            </div>
            <div class="modal__header-actions">
                <div class="modal__header-toggle">
                    <span class="modal__header-toggle-label">Active</span>
                    <ntv-toggle-button
                        [checked]="isHostActive()"
                        color="accent_color"
                        (checkedChange)="isHostActive.set($event)">
                    </ntv-toggle-button>
                </div>
                <svg
                    class="icon icon--hoverable"
                    width="23"
                    height="23"
                    (click)="isEditModalVisible.set(false)">
                    <use [attr.href]="spritePath + '#' + icons['close']"></use>
                </svg>
            </div>
        </div>
        <app-edit-screen
            [hostData]="rawHostData()"
            (cancelClick)="isEditModalVisible.set(false)"
            (deleteClick)="isEditModalVisible.set(false)"
            (updateClick)="isEditModalVisible.set(false)">
        </app-edit-screen>
    </ntv-modal>
}

@if (isAssignModalVisible()) {
    <ntv-modal
        [isVisible]="isAssignModalVisible()"
        [grayBackground]="false"
        (modalClose)="isAssignModalVisible.set(false)"
        modalWidth="500px"
        modalHeight="400px">
        <div modal-header class="modal__header" data-testid="single-host-modal-header-div">
            <div class="modal__header-title" data-testid="single-host-modal-header-title-div">
                <h3>Assign License</h3>
                <p>Check the licenses you wish to assign.</p>
            </div>
            <svg
                class="icon icon--hoverable"
                width="23"
                height="23"
                (click)="isAssignModalVisible.set(false)">
                <use [attr.href]="spritePath + '#' + icons['close']"></use>
            </svg>
        </div>

        <div class="modal__body" data-testid="single-host-modal-body-div">
            <div class="assign-license" data-testid="single-host-assign-license-div">
                <div class="assign-license__list" data-testid="single-host-assign-license-list-div">
                    @for (license of unassignedLicenses(); track license.id) {
                        <div
                            class="assign-license__item"
                            data-testid="single-host-assign-license-item-div">
                            <ntv-checkbox
                                size="sm"
                                [checked]="selectedAssignLicenseIds().has(license.id)"
                                (checkedChange)="toggleLicenseSelection(license.id)">
                            </ntv-checkbox>
                            <span
                                class="assign-license__label"
                                data-testid="single-host-assign-license-label-span"
                                >{{ license.alias }}</span
                            >
                        </div>
                    } @empty {
                        <div
                            class="assign-license__empty"
                            data-testid="single-host-assign-license-empty-div">
                            No unassigned licenses available.
                        </div>
                    }
                </div>

                <div
                    class="assign-license__footer"
                    data-testid="single-host-assign-license-footer-div">
                    <ntv-button
                        variant="primary"
                        size="md"
                        class="btn-cancel"
                        (buttonClick)="isAssignModalVisible.set(false)">
                        Cancel
                    </ntv-button>

                    <ntv-button
                        variant="accent"
                        size="xl"
                        class="btn-assign"
                        [disabled]="selectedAssignLicenseIds().size === 0"
                        (buttonClick)="onAssignLicenses()">
                        <div class="btn-content" data-testid="single-host-btn-content-div">
                            <span>Assign Licenses</span>
                            <svg width="14" height="14">
                                <use [attr.href]="spritePath + '#check'"></use>
                            </svg>
                        </div>
                    </ntv-button>
                </div>
            </div>
        </div>
    </ntv-modal>
}
